import React from "react";

export default function DtiKpiGrid({ items = [] }) {
  if (!items.length) return null;

  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") return "—";
    if (typeof value === "number") return value.toLocaleString("vi-VN");
    return value;
  };

  return (
    <div className="dti-kpi-grid">
      {items.map((item) => (
        <div className="dti-kpi-card" key={item.id || item.label}>
          <div className="dti-kpi-card__value">{formatValue(item.value)}</div>
          <div className="dti-kpi-card__label">{item.label}</div>
        </div>
      ))}
    </div>
  );
}
